export const CART_URL =
  "https://deceroatuempresadelimpieza.com/cart/add?id=50606257078497&quantity=1";

export const offer = {
  productName: "De cero a tu empresa de limpieza",
  // Precios tal como figuran hoy. Verificá que coincidan con el importe final del checkout de cada país.
  prices: [
    { country: "Argentina", amount: "AR$30.774,83" },
    { country: "Estados Unidos", amount: "US$19,99" },
    { country: "Brasil", amount: "R$102,00" },
  ],
  includes: [
    { title: "Ebook completo", detail: "189 páginas organizadas en 13 módulos" },
    { title: "8 bonos exclusivos", detail: "Guías prácticas en PDF" },
    { title: "Kit en el celular", detail: "27 atajos de WhatsApp, mensajes y checklists" },
    { title: "10 archivos PDF", detail: "Para descargar y consultar cuando quieras" },
  ],
};

export const images = {
  heroBackground:
    "https://cdn.magicpatterns.com/uploads/s7VMGxzwGzHhj9CrL4qkm3/Diseno_sin_titulo.png",
  heroMockup:
    "https://cdn.magicpatterns.com/uploads/9ZECccZs3RBNTrqJB7fP8K/favicon_empresa_limpieza_512.jpg",
  owner:
    "https://cdn.magicpatterns.com/patterns/generated-images/9b457b4f-6918-4744-8ff1-01584018ba44.jpg",
  team:
    "https://cdn.magicpatterns.com/patterns/generated-images/115c052e-794f-4dd2-ab18-856afde5635c.jpg",
  insidePages:
    "https://cdn.magicpatterns.com/patterns/generated-images/7eb08028-c4d3-40bd-88bc-bde2f5ccc419.jpg",
  bundle:
    "https://cdn.magicpatterns.com/uploads/8zk9aBvgtice5Qb7FXFEwH/fotografia_designada_.png",
};
